import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { logError } from "./lib/log";
import * as apiClient from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const me = await apiClient.getMe();
      setUser(me);
    } catch (err) {
      logError("auth-check", err);
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const doLogin = useCallback(async (data) => {
    const res = await apiClient.login(data);
    apiClient.setAccessToken(res.token);
    setUser(res.user);
    return res.user;
  }, []);
  const doRegister = useCallback(async (data) => {
    const res = await apiClient.register(data);
    apiClient.setAccessToken(res.token);
    setUser(res.user);
    return res.user;
  }, []);
  const doLogout = useCallback(async () => {
    try { await apiClient.logout(); } catch (err) { logError("logout", err); }
    apiClient.setAccessToken(null);
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, loading, setUser, checkAuth, doLogin, doRegister, doLogout }),
    [user, loading, checkAuth, doLogin, doRegister, doLogout],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
